module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audio",
    attrs: {
      "id": "BGMUSIC-SWF"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mask_visible),
      expression: "mask_visible"
    }],
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "category-nav"
  }, _vm._l((_vm.nav), function(item, index) {
    return _c('div', {
      class: {
        'active': item.active
      },
      on: {
        "click": function($event) {
          return _vm.handleNavChange(index, _vm.nav)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-inner"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_key),
      expression: "search_key"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入背景音"
    },
    domProps: {
      "value": (_vm.search_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_key = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-search button",
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search_key.length > 0),
      expression: "search_key.length > 0"
    }],
    staticClass: "el-icon-close button",
    on: {
      "click": _vm.handleSearchClose
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.music_play_status),
      expression: "music_play_status"
    }],
    staticClass: "player"
  }, [_c('div', {
    staticClass: "box-music"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("已选:   " + _vm._s(_vm.bgm_title)), _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.handleBgmCancle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "play_pause"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.play_status),
      expression: "play_status"
    }],
    staticClass: "icon-play",
    on: {
      "click": _vm.handleBgmPlay
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.play_status),
      expression: "!play_status"
    }],
    staticClass: "icon-pause",
    on: {
      "click": _vm.handleBgmPause
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.volume == 0),
      expression: "volume == 0"
    }],
    staticClass: "icon-mute",
    staticStyle: {
      "font-size": "24px",
      "color": "#4a4a4a"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.volume > 0),
      expression: "volume > 0"
    }],
    staticClass: "icon-voice",
    staticStyle: {
      "font-size": "24px",
      "color": "#4a4a4a"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "volume_change"
  }, [_c('el-slider', {
    staticStyle: {
      "-webkit-transform": "scale(0.55)",
      "width": "270px",
      "left": "-60px",
      "position": "relative"
    },
    attrs: {
      "step": 1
    },
    on: {
      "change": _vm.handleVolumeChange
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "volume_show"
  }, [_vm._v(_vm._s(_vm.volume))])])]), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "audio-bgm",
      "src": _vm.audio_player,
      "loop": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.no_result),
      expression: "no_result"
    }],
    staticClass: "no_results"
  }, [_vm._m(0)]), _vm._v(" "), (_vm.nav_status == 0) ? _c('div', {
    staticClass: "content",
    class: {
      position_top: _vm.music_play_status
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.search_status),
      expression: "!search_status"
    }],
    staticClass: "category-type"
  }, _vm._l((_vm.category_bgm_public), function(item, index) {
    return _c('div', {
      class: {
        'active': item.active
      },
      on: {
        "click": function($event) {
          return _vm.handleCategoryPublicChange(item, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "list",
    class: _vm.hideLeft
  }, [_c('div', {
    staticClass: "con"
  }, _vm._l((_vm.public_bgm_list), function(item, index) {
    return _c('div', {
      staticClass: "item",
      on: {
        "mousedown": function($event) {
          return _vm.handlePublicItemDown(item, $event)
        },
        "mouseup": function($event) {
          return _vm.handlePublicItemUp(item, $event)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "name"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _c('span', {
      staticClass: "tips"
    }, [_vm._v("免费")])]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      attrs: {
        "title": item.copyright
      }
    }, [_vm._v(_vm._s(item.copyright))])])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "more",
    on: {
      "click": _vm.handleMore
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._v("加载更多")])])])]) : _vm._e(), _vm._v(" "), (_vm.nav_status == 1) ? _c('div', {
    staticClass: "content",
    class: {
      position_top: _vm.music_play_status
    }
  }, [_c('div', {
    staticClass: "list",
    staticStyle: {
      "left": "0"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.breadcrumb), function(item, index) {
    return (_vm.breadcrumb.length > 1) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.handleTargetNav(index, item.folder_id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name == '根文件夹' ? item.name : '/ ' + item.name) + "\n        ")]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, _vm._l((_vm.self_bgm_list), function(item) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.handleItemFolderSelf(item)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "pic"
    }, [(item.type == 'folder') ? _c('img', {
      attrs: {
        "src": require("./folder.png")
      }
    }) : _vm._e(), _vm._v(" "), (item.type != 'folder') ? _c('img', {
      attrs: {
        "src": require("./music.png")
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "name"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), (item.type != 'folder') ? _c('span', {
      staticClass: "tips"
    }, [_vm._v("免费")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      attrs: {
        "title": item.copyright
      }
    }, [_vm._v(_vm._s(item.copyright))])])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "more",
    on: {
      "click": _vm.handleMore
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._v("加载更多")])])])]) : _vm._e(), _vm._v(" "), (_vm.nav_status == 2) ? _c('div', {
    staticClass: "content",
    class: {
      position_top: _vm.music_play_status
    }
  }, [_c('div', {
    staticClass: "list",
    staticStyle: {
      "left": "0"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.breadcrumb), function(item, index) {
    return (_vm.breadcrumb.length > 1) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.handleTargetNav(index, item.folderId)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name == '根文件夹' ? item.name : '/ ' + item.name) + "\n        ")]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, _vm._l((_vm.team_bgm_list), function(item) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.handleItemFolderSelf(item)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "pic"
    }, [(item.type == 'folder') ? _c('img', {
      attrs: {
        "src": require("./folder.png")
      }
    }) : _vm._e(), _vm._v(" "), (item.type != 'folder') ? _c('img', {
      attrs: {
        "src": require("./music.png")
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "name"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), (item.type != 'folder') ? _c('span', {
      staticClass: "tips"
    }, [_vm._v("免费")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      attrs: {
        "title": item.copyright
      }
    }, [_vm._v(_vm._s(item.copyright))])])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.more),
      expression: "more"
    }],
    staticClass: "more",
    on: {
      "click": _vm.handleMore
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._v("加载更多")])])])]) : _vm._e(), _vm._v(" "), (_vm.platform == 'qt') ? _c('psocket', {
    attrs: {
      "attributes": _vm.attributes,
      "flashvars": _vm.flashvars
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("./no_result.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("./music.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52e492a2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bgm/Bgm.vue
// module id = 392
// module chunks = 0